/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */

/* eslint-disable */
import React,  { useState, useRef, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import shortid from 'shortid';

import ReCAPTCHA from "react-google-recaptcha";

// components
import { Grid, Input, Message, Checkbox } from '@design-system-coopeuch/web';
import SkeletonInputTextAndLabel from '../../molecules/SkeletonInputTextAndLabel/SkeletonInputTextAndLabel';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import Skeleton from '../../atoms/Skeleton/Skeleton';
import { useModal } from '../../../hooks/useModal';
import ContentSerialNumber from '../../molecules/ContentSerialNumber';
import ItemValidation from '../../molecules/ItemValidation/ItemValidation';
import Modal from '../../organisms/Modal/Modal';
import Survey from '../../../containers/Survey/Survey';
import { personalDataActions } from '../../../../application/actions/personalData';

// assets
import iconQuestion from '../../../assets/img/icon-question.svg';
// styles
import { StyledWrapperInput, StyledButton, WrapperCheckboxs, WrapperCheckbox, StyledWrapperMessage } from '../../../assets/styles/styles';
// constans
import { MAX_RUT_WITH_OR_WITHOUT_DASH, MAX_SERIAL_NUMBER } from '../../../../domain/constants';

 /* istanbul ignore next */
const tokenKey = process.env.REACT_APP_RECAPTCHA_KEY

 /* istanbul ignore next */
const CardPersonValidation = (props) => {
  const {
    rut,
    serialNumber,
    isValidPerson,
    previredAuthorization,
    showIsRequiredPreviredAuthorization,
    isMobileDevice,
    isCompletedCardPersonValidation,
    isLoadingValidatePersonalData,
    isOpenModalAlreadyMemberRedirection,
    onValidatePerson,
    onChange,
  } = props;
   /* istanbul ignore next */
  const dispatch = useDispatch();
   /* istanbul ignore next */
  const validSerialNumber = useSelector(state => state.entities.personalData);

  const [isOpen, openModal, closeModal] = useModal(false);
  const [isOpenModalCedule, openModalCedule, closeModalCedule] = useModal(false);

  const [tokenCaptcha, setTokenCaptcha] = useState();
   /* istanbul ignore next */
  const { badSerialNumber } = validSerialNumber
   /* istanbul ignore next */
  const recaptchaInstance = useRef(null);
   /* istanbul ignore next */
  const onChangeCaptcha = () => {
    if (recaptchaInstance.current.getValue()) {
      setTokenCaptcha(recaptchaInstance.current.getValue());
      sessionStorage.setItem('authToken',recaptchaInstance.current.getValue());
    }
  };
   /* istanbul ignore next */
  const onExpired = () =>{
    setTokenCaptcha(null);
  }
  /* istanbul ignore next */
  const onErrored = ()=>{
    setTokenCaptcha(null);
  }
   /* istanbul ignore next */
  const revertStateSerialNumber = () => {
    dispatch(personalDataActions.changeStateBadSerial({ stateSerial: false }));
  }
   /* istanbul ignore next */
  useEffect(() => {
    if (badSerialNumber) {
      onChange({
        field: 'previredAuthorization',
        property: 'value',
        value: false,
      });

      if (recaptchaInstance.current) {
        recaptchaInstance.current.reset();
      }

      setTokenCaptcha(null);
      sessionStorage.removeItem('authToken');
    }
  }, [badSerialNumber]);
   /* istanbul ignore next */
  return isValidPerson ? (
    <Grid row className="m-0 p-0 w-100">
      <StyledWrapperMessage>
        <Message
          className="w-100"
          type="info"
          description="Tu cédula de identidad ha sido validada con éxito."
          closer={null}
        />
      </StyledWrapperMessage>
    </Grid>
  ) : (
    <>
      <SimpleCard
        contentHeader={
          <p className="simplecard__title">Para comenzar, verificaremos tu cédula de identidad</p>
        }
      >
        <Grid className="m-0 padding-16 p-md-6">
          <Grid row className="m-0">
            <Grid
              className={`p-0 pr-md-4 ${
                isLoadingValidatePersonalData ? 'mb-4 mb-md-2' : 'mb-2 mb-md-0'
              }`}
              col={12}
              md={4}
            >
              {isLoadingValidatePersonalData ? (
                <SkeletonInputTextAndLabel />
              ) : (
                <StyledWrapperInput>
                  <Input
                    label="RUT"
                    value={rut.value}
                    maxLength={MAX_RUT_WITH_OR_WITHOUT_DASH}
                    assistText={
                      rut.errors.length > 0 ? rut.errors : [{ text: 'Sin puntos', type: 'assist' }]
                    }
                    onChange={(value) =>
                      onChange({
                        field: 'rut',
                        property: 'value',
                        value,
                      })
                    }
                    error={rut.errors.length > 0}
                    autoComplete="new-password"
                  />
                </StyledWrapperInput>
              )}
            </Grid>
            <Grid
              className={`p-0 pr-md-4 ${
                isLoadingValidatePersonalData ? 'mb-4 mb-md-2' : 'mb-2 mb-md-0'
              }`}
              col={12}
              md={4}
            >
              {isLoadingValidatePersonalData ? (
                <SkeletonInputTextAndLabel />
              ) : (
                <StyledWrapperInput>
                  <button
                    type="button"
                    tabIndex="-1"
                    onClick={openModalCedule}
                    className="btn-tooltip-label border-0 p-0 m-0 d-flex"
                  >
                    <img className="img-show-detail" src={iconQuestion} alt="" />
                  </button>
                  <Input
                    label="Nº de serie o documento"
                    value={serialNumber.value}
                    maxLength={MAX_SERIAL_NUMBER}
                    assistText={
                      serialNumber.value.trim() === ''
                        ? [{ text: 'Sin puntos', type: 'assist' }]
                        : badSerialNumber
                          ? [{ text: 'El número ingresado es incorrecto', type: 'error' }]
                          : serialNumber.errors.length > 0
                            ? serialNumber.errors
                            : [{ text: 'Sin puntos', type: 'assist' }]
                    }
                    onChange={(value) => {
                      onChange({
                        field: 'serialNumber',
                        property: 'value',
                        value,
                      });
                      if (/* value.trim() === '' && */ badSerialNumber) {
                        revertStateSerialNumber();
                      }
                    }}
                    error={serialNumber.errors.length > 0 || badSerialNumber}
                    autoComplete="new-password"
                  />
                </StyledWrapperInput>
              )}
            </Grid>
          </Grid>
          <Grid className="m-0 p-0 mt-2 d-flex flex-column flex-md-row">
            {isLoadingValidatePersonalData ? (
              <Skeleton height="24px" width={isMobileDevice ? '100%' : '680px'} mb={12} />
            ) : (
              <>
                <WrapperCheckboxs>
                  <WrapperCheckbox
                    validationStatus={
                      showIsRequiredPreviredAuthorization && !previredAuthorization.value
                        ? 'required'
                        : 'default'
                    }
                    key={shortid.generate()}
                  >
                    <Checkbox
                      id="121212"
                      label="Confirmo que leí y estoy de acuerdo con el documento de  "
                      checked={previredAuthorization.value}
                      onChange={(e) =>
                        onChange({
                          field: 'previredAuthorization',
                          property: 'value',
                          value: e,
                        })
                      }
                    />
                  </WrapperCheckbox>
                </WrapperCheckboxs>
                <button
                  type="button"
                  onClick={() => openModal()}
                  className="btn-without-format--red-underline mt-1 mt-md-0 text-color-info"
                >
                  Consentimiento del tratamiento de datos.
                </button>
              </>
            )}
          </Grid>
          {showIsRequiredPreviredAuthorization && !previredAuthorization.value && (
            <ItemValidation className="mt-0 ml-0 ml-md-4" type="error">
              Debes confirmar tu consentimiento para continuar
            </ItemValidation>
          )}
             <ReCAPTCHA
            sitekey={tokenKey}
            ref={recaptchaInstance}
            className='catpcha-main'
            onChange={onChangeCaptcha}
            onExpired={()=>onExpired()}
            onErrored={()=>{onErrored()}}
          />
        </Grid>
        <Grid
          row
          className="m-0 padding-16 p-md-6 align-items-center justify-content-end border-top border-neutral-alfa-15"
        >
          <Grid col={12} md={4} className="m-0 p-0">
            <StyledButton
              variant="default"
              color="secondary"
              onClick={() => {
                if (tokenCaptcha && !badSerialNumber) {
                  onValidatePerson();
                }
              }}
              className="w-100 d-flex justify-content-center"
              appearanceDisabled={!isCompletedCardPersonValidation || isLoadingValidatePersonalData || !tokenCaptcha || badSerialNumber}
            >
              Verificar mi cédula
            </StyledButton>
          </Grid>
        </Grid>
      </SimpleCard>
      <Modal isOpen={isOpenModalAlreadyMemberRedirection} unableToClose>
        <Survey type="alreadyMember" />
      </Modal>
      <Modal isOpen={isOpen} closeModal={closeModal} closeClickOutside closeEscKey>
        <section className="d-flex flex-column width-lg-750px h-100">
          <Grid className="p-0 m-0 px-6 py-4 border-bottom border-neutral-alfa-15 flex-0-1-auto">
            <p className="font-size-24 line-height-30 font-weight-bold">
              Consentimiento del tratamiento de datos
            </p>
          </Grid>
          <Grid className="p-0 m-0 p-6 d-flex flex-column flex-1-1-auto overflow-auto">
            <p className="font-size-14 line-height-20 mb-2">
              De acuerdo a la Ley 19.628 “Sobre Protección de la Vida Privada”, Coopeuch hará uso de
              los datos personales que nos compartas con finalidades específicas y explicadas en
              detalle más abajo.
            </p>
            <p className="mb-2 font-size-14 line-height-20 font-weight-bold">
              Datos personales requeridos:
            </p>
            <Grid row className="m-0 p-0">
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 margin-bottom-4 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">Rut</li>
                  <li className="text-color-38 font-size-14 line-height-18">N° Serie Documento</li>
                  <li className="text-color-38 font-size-14 line-height-18">Nombre completo</li>
                  <li className="text-color-38 font-size-14 line-height-18">Profesión u Oficio</li>
                  <li className="text-color-38 font-size-14 line-height-18">Actividad Laboral</li>
                  <li className="text-color-38 font-size-14 line-height-18">Cargo</li>
                  <li className="text-color-38 font-size-14 line-height-18">Email</li>
                </ul>
              </Grid>
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 mb-0 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">Teléfono Celular</li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Dirección Particular
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Declaración Ley Fatca
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Validación de Identidad
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Monto cuota de participación
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Encuesta de preferencias
                  </li>
                </ul>
              </Grid>
            </Grid>
            <p className="mb-2 mt-3 font-size-14 line-height-20 font-weight-bold">
              Cómo serán tratados tus datos:
            </p>
            <Grid row className="m-0 p-0">
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 margin-bottom-4 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">
                    Materializar y ejecutar la contratación de productos o servicios de tu elección.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Ser utilizados para fines estadísticos internos de Coopeuch.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Revisar vigencia de tu cédula identidad y realizar consultas con el registro
                    civil.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Realizar elaboración de perfiles y riesgos en relación a morosidades o
                    protestos.
                  </li>
                </ul>
              </Grid>
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 mb-0 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">
                    Realizar consultas a fuentes externas.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Realizar consultas sobre tus últimas cotizaciones previsionales.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Coordinar la entrega de tus productos.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Enviar información de carácter comercial ofreciéndote nuevos incentivos,
                    beneficios, productos o servicios que se ajusten a tus necesidades.
                  </li>
                </ul>
              </Grid>
            </Grid>
            <p className="font-size-14 line-height-20 mt-3">
              Sin perjuicio de lo anterior, podrás disponer en todo momento de los derechos de
              información, modificación y cancelación de tus datos personales y los demás que
              establece la Ley 19.628 “Sobre Protección de la Vida Privada”, o la ley que la
              reemplace y/o modifique en el futuro.
            </p>
          </Grid>
          <Grid className="m-0 p-0 py-5 px-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15 flex-0-1-auto">
            <StyledButton
              variant="default"
              disabled={false}
              onClick={closeModal}
              color="secondary"
              className="text-align-center"
            >
              Entendido
            </StyledButton>
          </Grid>
        </section>
      </Modal>
      <Modal isOpen={isOpenModalCedule} closeModal={closeModalCedule} closeClickOutside closeEscKey>
        <ContentSerialNumber onClickButton={closeModalCedule} />
      </Modal>
    </>
  );
};

CardPersonValidation.defaultProps = {
  rut: {},
  serialNumber: {},
  isValidPerson: false,
  isLoadingValidatePersonalData: false,
  onValidatePerson: () => null,
  onChange: () => null,
};
CardPersonValidation.propTypes = {
  rut: PropTypes.shape({
    value: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape()),
  }),
  serialNumber: PropTypes.shape({
    value: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isValidPerson: PropTypes.bool,
  isLoadingValidatePersonalData: PropTypes.bool,
  onValidatePerson: PropTypes.func,
  onChange: PropTypes.func,
};

export default CardPersonValidation;
